module.exports = __webpack_public_path__ + "img/07.bac79d3e.png";